<template>
  <div class="flex-column list top start" style="background:transparent" >
  <img src="/static/system/logo.png" style="width:100%" />
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    config: Object,
  },
  created() {
    console.log(this.config);
  },
};
</script>

<style scoped>
.image {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin: 0 auto !important;
}
</style>
